import template from 'text!./templates/file-upload-viewer.html';

var uploadInProgress = false; // Only one file upload dialog at a time

export default [function () {
    return {
        'scope': {
            'uploadConfig': '=',
            'documents': '=',
            'dropZoneSelector': '&',
            'hideDropArea': '&',
            'removeFunction': '&'
        },
        'template': template,
        'controller': ['$scope', '$timeout', '$q', '$filter', 'ModalService', function ($scope, $timeout, $q, $filter, ModalService) {
            var fileIcons = {
                doc: 'fa-file-word-o',
                docx: 'fa-file-word-o',
                docm: 'fa-file-word-o',
                pdf: 'fa-file-pdf-o',
                xlt: 'fa-file-excel-o',
                xlsx: 'fa-file-excel-o',
                xlsm: 'fa-file-excel-o',
                gif: 'fa-file-image-o',
                png: 'fa-file-image-o',
                jpeg: 'fa-file-image-o'
            };

            $scope.dragDropSelector = $scope.dropZoneSelector() || '.gw-file-upload-drag-area';
            $scope.removeDocument = function (document) {
                if (!document.canDelete) {
                    return;
                }
                var title = 'platform.widgets.fileupload.templates.Remove Document';
                var msg = $filter('translate')('platform.widgets.fileupload.templates.Are you sure you want to remove:', {
                    documentName: document.name
                });

                ModalService.showWarning(title, msg).result.then(function () {
                    $q.when($scope.removeFunction({ documentID: document.publicID }), function (deleted) {
                        if (deleted === true) {
                            // Filter out deleted doc
                            $scope.documents = $scope.documents.filter(function (doc) {
                                return doc.workingPublicID !== document.publicID;
                            });
                        } else {
                            ModalService.showError('platform.widgets.fileupload.templates.Document Deletion May Have Failed', 'platform.widgets.fileupload.templates.Something may have gone wrong when deleting your document.');
                        }
                    }, function () {
                        ModalService.showError('platform.widgets.fileupload.templates.Unable to Delete Document', 'platform.widgets.fileupload.templates.Sorry, your document could not be deleted at this time.');
                    });
                });
            };

            $scope.getFileIcon = function (file) {
                var extension = _getFileExtension(file.docUID).toLowerCase() || '';
                return fileIcons[extension] || 'fa-file-o';
            };

            $scope.clickUpload = function () {
                if (!uploadInProgress && !$scope.hideDropArea()) {
                    var uploadElement = $('.' + $scope.uploadConfig.uploaderClass + ' input');
                    if (uploadElement.length !== 0) {
                        uploadInProgress = true;

                        // Wrap in timeout to call after current digest
                        $timeout(function () {
                            // Clicks the upload area to trigger the upload dialog
                            uploadElement[0].click();
                            uploadInProgress = false;
                        });
                    }
                }
            };

            function _getFileExtension(name) {
                var extension = name.split('.').pop();
                return extension || '';
            }
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/fileupload/FileUploadViewer.js
// module id = 1116
// module chunks = 0